import { getStore } from '../store/store';
import { mutatorAction } from 'satcheljs';

export const addUpdatedSavedViewIds = mutatorAction(
    'addUpdatedSavedViewIds',
    (savedViewId: string) => {
        getStore().updatedSavedViewIds.push(savedViewId);
    }
);
